export default class ValidationPhone {
    static validate(number) {
        if (number) {
            const regex = /^([+]46|0)?\s*(7[02369])\s*(\d{4})\s*(\d{3})$/;
            number = number.replace(/\s/g, '');
            if (number.match(regex)) {
                return true;
            }
        }
        return false;
    }
}
